import { useGameStore } from '../../store/gameStore';
import { GameMode, LeaderboardData } from '@/types/types';
import { bannedWords } from '../../../constants/bannedWords';
import { getFunctionBaseUrl } from './urlHelper';

export async function writeToLeaderboard() {
  const mode = useGameStore.getState().mode;
  const username = useGameStore.getState().username;
  const gameId = useGameStore.getState().gameData[mode].gameId;
  const entry: LeaderboardData = {
    id: gameId,
    score: useGameStore.getState().gameData[mode].points,
    name:
      username !== '' && !bannedWords.includes(username.toLowerCase())
        ? username
        : 'User' + gameId.toString().substring(0, 4),
    actionsList: useGameStore.getState().gameData[mode].actionsList,
    gameMode: mode,
  };

  const baseUrl = getFunctionBaseUrl();
  const url = `${baseUrl}/.netlify/functions/writeToLeaderboard`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(entry),
    });

    const result = await response.json();

    if (response.ok) {
      useGameStore.getState().setSubmittedScore();
    }

    if (!response.ok) {
      console.error('Failed to submit score:', result);
      return { success: false, message: result.message };
    }

    return { success: true, data: result };
  } catch (err) {
    console.error('Network error submitting score:', err);
    return { success: false, message: 'Network error' };
  }
}

const gameModes: GameMode[] = ['blitzSimple', 'blitzDeluxe', 'endlessSimple', 'endlessDeluxe'];

export async function fetchAllLeaderboards() {
  const state = useGameStore.getState();

  const leaderboardResults = await Promise.all(
    gameModes.map(async (mode) => {
      const gameId = state.gameData[mode]?.gameId;
      const data = await fetchLeaderboardData(mode, gameId.toString());
      return { gameMode: mode, ...data };
    })
  );

  return leaderboardResults;
}

async function fetchLeaderboardData(gameMode: string, gameId: string) {
  const baseUrl = getFunctionBaseUrl();
  const url = `${baseUrl}/.netlify/functions/readLeaderboard?gameMode=${gameMode}&gameId=${gameId}`;
  const res = await fetch(url);

  if (!res.ok) throw new Error(`Failed to fetch leaderboard for ${gameMode}`);
  return res.json();
}
